import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Collapse, TableCell, TableRow } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { dropdownContentSx, getDropdownCellSx, handleExpandRowKeyDown } from './campaignScheduleTabLayout';

interface SummaryRowProps {
  children: React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
  sx?: SxProps<Theme>;
}

export function CampaignScheduleSummaryRow({ children, isExpanded, onToggle, sx }: SummaryRowProps) {
  return (
    <TableRow
      hover
      role="button"
      sx={{ cursor: 'pointer', ...sx }}
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(event) => handleExpandRowKeyDown(event, onToggle)}
    >
      <TableCell>{isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</TableCell>
      {children}
    </TableRow>
  );
}

interface DropdownRowProps {
  children: React.ReactNode;
  colSpan: number;
  isExpanded: boolean;
}

export function CampaignScheduleDropdownRow({ children, colSpan, isExpanded }: DropdownRowProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={getDropdownCellSx(isExpanded)}>
        <Collapse unmountOnExit in={isExpanded} sx={{ width: '100%' }} timeout="auto">
          <Box sx={dropdownContentSx}>{children}</Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
